// Namespace "templates" — libellés du registre de modèles de site et replis des templates.
// Créé vide lors du split ; le lot J apporte son fragment.
export default { fr: {}, en: {}, es: {} };
